import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import "./VisionMission.css";
import Footer from "../components/Footer";
import Navbar from "../components/navbar";
import CTAButtons from "../components/sticky-button";
import PageHeader from "./PageHeader";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

const VisionMission = () => {
  const [showForm, setShowForm] = useState(false);
  const asset = (path) => `${process.env.PUBLIC_URL}${path.startsWith('/') ? path : `/${path}`}`;
  
  return (
    <>
      <Navbar />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />
    <PageHeader
          title="Vision & Mission"
          crumbs={[
            { label: "Home", href: "/" },
            { label: "Rules & Guidelines" },
          ]}
        />
      <main className="vision-mission-container">
    

        {/* Vision & Mission */}
        <section className="vm-section">
          {/* Vision */}
          <article className="vm-block vm-block--reverse">
            <div className="vm-media">
          <img
  src={asset('/About/Vision.webp')}
  loading="lazy"
  alt="Vision illustration for Thakur Institute"
  className="vm-img"
/>
            </div>
            <div className="vm-content">
              <h2>Our Vision</h2>
              <div className="vm-underline" aria-hidden="true" />
              <p>
                Thakur Institute of Management Studies, Career Development & Research will become a premier institute renowned internationally for providing education in software application to graduates from various disciplines.
              </p>
            </div>
          </article>

          {/* Mission */}
          <article className="vm-block">
            <div className="vm-media">
              <img
                src={asset('/About/Mission.webp')}
                loading="lazy"
                alt="Mission illustration for Thakur Institute"
                className="vm-img"
              />
            </div>
            <div className="vm-content">
              <h2 >Our Mission</h2>
              <div className="vm-underline" aria-hidden="true" />
              <p >
               To achieve excellence in providing software education so that students can grasp existing as well as emerging technologies and to inculcate leadership and managerial qualities in them so that they can deliver results in the organization they join.
              </p>
            </div>
          </article>
        </section>


      </main>
      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />

      <Footer />
    </>
  );
};

export default VisionMission;
